import { Injectable, inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, CanActivateChild, Router, RouterStateSnapshot } from '@angular/router';
import { paths } from '@platform/paths';
import { AuthService } from '@shared/services/auth.service';
import { Observable, of } from 'rxjs';

@Injectable()
export class AuthenticatedGuard implements CanActivate, CanActivateChild {
  private readonly router = inject(Router);
  private readonly authService = inject(AuthService);

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | boolean {
    if (this.authService.tokenValid() && !route.queryParams.data && !route.queryParams.token) {
      void this.router.navigateByUrl(`/${paths.PLATFORM}`);
      return of(false);
    }
    return of(true);
  }

  canActivateChild(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    if (this.authService.tokenValid() && !route.queryParams.data && !route.queryParams.token) {
      void this.router.navigateByUrl(`/${paths.PLATFORM}`);
      return of(false);
    }
    return of(true);
  }
}
